import { Helmet } from 'react-helmet-async';

const BASE_TITLE = 'Droid.pl';
const BASE_URL = 'https://droid.pl';

export default function SEO({ title, description, path, noIndex }) {
  const fullTitle = title ? `${title} | ${BASE_TITLE}` : `${BASE_TITLE} - narzędzie do automatycznej optymalizacji kampanii Google Ads`;
  const url = path ? `${BASE_URL}${path}` : BASE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
